import {Injectable} from '@angular/core';
import {SETTINGS} from "../config/common.settings";
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, Observable, of, Subject} from "rxjs";
import {catchError, debounceTime, map, switchMap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class GooglePlacesService {
  getAutoComplete: any;
  textSearch: any;
  placeDetail: any = [];
  findPlaceDetail: any;
  placePhoto: any;
  onFindPlaceDetailsChange: Subject<any> = new Subject();

  constructor(private http: HttpClient) {
  }

  postAutoComplete(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/places/get`, payload)
        .subscribe({
          next: (response: any) => {
            this.getAutoComplete = response;
            resolve(this.getAutoComplete);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getPlaceDetails(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/places/details/${id}`)
        .subscribe({
          next: (response: any) => {
            this.placeDetail = response;
            resolve(this.placeDetail);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getLocation(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/places/long-lang/${id}`)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  postTextSearch(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/places/text-search`, payload)
        .subscribe({
          next: (response: any) => {
            this.textSearch = response.places[0];
            resolve(this.textSearch);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }


  getPlacePhoto(url: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/places/photo` , url)
        .subscribe({
          next: (response: any) => {
            this.placePhoto = response;
            resolve(this.placePhoto);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }


  destinationExistGoogleDetails(id: any, type: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/places/destination-exist-get-details/${id}/${type}`)
        .subscribe({
          next: (response: any) => {
            this.findPlaceDetail = response;
            this.onFindPlaceDetailsChange.next(this.findPlaceDetail);
            resolve(this.findPlaceDetail);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  experiencesExistGoogleDetails(id: any, type: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/places/experience-exist-get-details/${id}/${type}`)
        .subscribe({
          next: (response: any) => {
            this.findPlaceDetail = response;
            this.onFindPlaceDetailsChange.next(this.findPlaceDetail);
            resolve(this.findPlaceDetail);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  newPostAutoComplete = (payload: any): Observable<any> => {
    return this.http.post(`${SETTINGS.BASE_API}/places/get`, payload)
      .pipe(catchError(() => of({})),
        map((res: any) => res))
      .pipe(map((list: any) => list));
  }
}
